import { styled } from "styled-components";

export const GeneralDetailsFormContainer = styled.div`
.MuiFormLabel-root {
    color: #000 !important;
}

.Mui-focused {
    color: #000 !important;
}

  .form-container {
    display: flex;
    align-items: flex-start;
    .customer_details-select {
      max-width: 200px;
    }
    .responsive-input {
      max-width: 31vw;
    }
    @media (max-width: 575.98px) {
      display: unset;
    }
    .responsive-MobileInput {
      /* bottom: 14px; */
      @media (max-width: 575.98px) {
        /* bottom: 0; */
        margin-bottom: 1rem;
      }
    }
    .customInput {
      height: calc(2.2125rem + -5px);
    }
    .customInput:hover {
      border-color: #00a4e5;
      color: #575962;
      box-shadow: none;
    }
    .customSelect {
      @media (max-width: 575.98px) {
        width: 100%;
      }
    }
  }
`;
